import React, { useEffect } from "react";
import apiHelper from "services/apiHelper";

const PrintIPN = () => {
  useEffect(() => {
    async function fetchAPI() {
      try {
        await apiHelper(`api/printIPN`);
      } catch (error) {
        console.error("PrintIPN API error", error);
      }
    }
    fetchAPI();
  }, []);
  return <div></div>;
};

export default PrintIPN;